import React, { SVGProps } from "react";
const SvgFinanceEconomy = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={29.512} viewBox="0 0 29.512 30.439" {...props}>
      <g data-name="Finance Economy">
        <g data-name="Group 212">
          <g data-name="Group 196">
            <g data-name="Group 195">
              <g data-name="Group 194">
                <g data-name="Group 191">
                  <g data-name="Group 190">
                    <path
                      data-name="Path 676"
                      d="M18.192 5.642S21.109 1.856 20.27.77c-.286-.37-.53.133-1.121.133-.695 0-.695-.454-1.389-.454s-.695.454-1.389.454-.694-.454-1.389-.454-.694.454-1.389.454c-.592 0-.835-.509-1.122-.139-.839 1.08 2.035 4.878 2.035 4.878-12.693 8.345-8.6 19.693-1.106 19.693h5.944c7.516 0 11.584-11.32-1.152-19.693Z"
                      fill="#12b05e"
                    />
                  </g>
                </g>
                <g data-name="Group 192">
                  <path
                    data-name="Path 677"
                    d="M18.193 5.642S21.11 1.856 20.271.77c-.286-.37-.53.133-1.121.133-.695 0-.695-.454-1.389-.454s-.695.454-1.389.454h-.1a15.013 15.013 0 0 1-2.256 4.058c.283.416.487.685.487.685q-.254.167-.5.336c12.128 8.336 8.07 19.357.653 19.357h4.683c7.517 0 11.584-11.32-1.151-19.693Z"
                    fill="#03984b"
                  />
                </g>
                <g data-name="Group 193">
                  <path
                    data-name="Path 678"
                    d="M18.735 6.989a10.147 10.147 0 0 1-5.064 0 1.081 1.081 0 0 1-.712-1.415l.007-.02a1 1 0 0 1 1.178-.665 8.245 8.245 0 0 0 4.119 0 1 1 0 0 1 1.178.665l.007.02a1.081 1.081 0 0 1-.713 1.415Z"
                    fill="#ffe07d"
                  />
                </g>
              </g>
            </g>
          </g>
          <g data-name="Group 211">
            <g data-name="Group 210">
              <g data-name="Group 209">
                <g data-name="Group 208">
                  <g data-name="Group 207">
                    <g data-name="Group 206">
                      <g data-name="Group 205">
                        <g data-name="Group 204">
                          <g data-name="Group 203">
                            <g data-name="Group 202">
                              <g data-name="Group 201">
                                <g data-name="Group 200">
                                  <g data-name="Group 197">
                                    <path
                                      data-name="Path 679"
                                      d="m2.8 27.282 6.454 2.4a4.912 4.912 0 0 0 1.713.309h6.65a4.912 4.912 0 0 0 2.629-.763l8.329-5.278a1.462 1.462 0 0 0 .238-1.916 1.485 1.485 0 0 0-2.024-.391l-8.109 3.57.01-1.316a2.355 2.355 0 0 0-2.013-2.1l-4.938-.569a6.515 6.515 0 0 1-2.7-1.124 8.85 8.85 0 0 0-4.469-1.211H2.8Z"
                                      fill="#ffddce"
                                    />
                                  </g>
                                  <g data-name="Group 198">
                                    <path
                                      data-name="Path 680"
                                      d="m2.8 27.282 6.454 2.4a4.912 4.912 0 0 0 1.713.309h6.65a4.912 4.912 0 0 0 2.629-.763l8.329-5.278a1.462 1.462 0 0 0 .238-1.916 1.485 1.485 0 0 0-2.024-.391l-8.109 3.57.01-1.316a2.355 2.355 0 0 0-2.013-2.1l-4.938-.569a6.515 6.515 0 0 1-2.7-1.124 8.85 8.85 0 0 0-4.469-1.211H2.8Z"
                                      fill="#ffddce"
                                    />
                                  </g>
                                  <path
                                    data-name="Path 681"
                                    d="M28.816 22.037a1.485 1.485 0 0 0-2.024-.391l-2.23.982.194.307a1.462 1.462 0 0 1-.238 1.915l-4.853 3.075a4.911 4.911 0 0 1-2.044.446h-6.653a4.911 4.911 0 0 1-1.714-.308l-6.454-2.4v1.62l6.454 2.4a4.912 4.912 0 0 0 1.713.309h6.649a4.912 4.912 0 0 0 2.629-.763l8.329-5.278a1.462 1.462 0 0 0 .242-1.914Z"
                                    fill="#ffcbbe"
                                  />
                                  <g data-name="Group 199">
                                    <path
                                      data-name="Path 682"
                                      d="M18.082 22.546v.032l.021-.009Z"
                                      fill="#f5dbcc"
                                    />
                                  </g>
                                </g>
                              </g>
                              <path
                                data-name="Path 683"
                                d="M4.188 28.568a.848.848 0 0 1-.848.848H1.294a.848.848 0 0 1-.848-.848V18.185a.848.848 0 0 1 .848-.848h2.047a.848.848 0 0 1 .848.848Z"
                                fill="#ffcd27"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g data-name="Group 213">
          <path
            data-name="Path 684"
            d="M29.183 21.787a1.914 1.914 0 0 0-2.58-.546l-.555.244a9.17 9.17 0 0 0 .548-5.9 14.243 14.243 0 0 0-3.589-6.49.446.446 0 0 0-.657.6 13.369 13.369 0 0 1 3.376 6.08 7.994 7.994 0 0 1-1.046 6.314l-5.547 2.443v-.627a.436.436 0 0 0 0-.047 2.794 2.794 0 0 0-2.394-2.5h-.011l-4.932-.568c-1.9-.27-2.385-1.407-4.954-2.055a9.6 9.6 0 0 1 .707-4.717 16.987 16.987 0 0 1 5.537-6.817c.987.7 5.391.787 6.376-.116.5.383.987.779 1.436 1.178a.446.446 0 1 0 .593-.666 24.963 24.963 0 0 0-1.576-1.289 1.587 1.587 0 0 0-.532-1.581c1.4-2.117 1.8-3.5 1.241-4.229a.779.779 0 0 0-1.07-.164.715.715 0 0 1-.851-.033 1.6 1.6 0 0 0-1.877 0 .719.719 0 0 1-.9 0 1.6 1.6 0 0 0-1.877 0 .71.71 0 0 1-.854.029.778.778 0 0 0-1.076.161c-.548.706-.181 2.048 1.12 4.093a1.452 1.452 0 0 0-.227.151 3.01 3.01 0 0 0-2.593-.98 3.267 3.267 0 0 1-2.216-.524.447.447 0 1 0-.5.741 4.151 4.151 0 0 0 2.813.67 2.178 2.178 0 0 1 1.991.871l-.015.057a7.651 7.651 0 0 0-1.414.154 4.186 4.186 0 0 0-2.9 1.858.446.446 0 1 0 .77.45c.813-1.389 2.8-1.559 3.585-1.57l.011.029a17.615 17.615 0 0 0-5.822 7.2 10.581 10.581 0 0 0-.8 4.868 9.277 9.277 0 0 0-1.295-.1v-.27a1.3 1.3 0 0 0-1.294-1.294H1.294a1.3 1.3 0 0 0-1.291 1.29v10.383a1.3 1.3 0 0 0 1.294 1.294h2.047a1.3 1.3 0 0 0 1.294-1.294v-.127l4.465 1.66a5.341 5.341 0 0 0 1.869.336h6.652a5.35 5.35 0 0 0 2.868-.832c8.874-5.625 8.335-5.275 8.386-5.321a1.912 1.912 0 0 0 .311-2.5ZM18.626 6.557a9.663 9.663 0 0 1-4.846 0c-.7-.177-.5-1.425.255-1.236a8.694 8.694 0 0 0 4.336 0c.739-.186.966 1.056.255 1.236Zm-5.843-5.432.01.005a1.582 1.582 0 0 0 1.739-.081c.76-.5.842.3 1.839.3a1.549 1.549 0 0 0 .939-.3.719.719 0 0 1 .9 0 1.59 1.59 0 0 0 1.746.08c.092.331-.116 1.316-1.438 3.285a9.08 9.08 0 0 1-4.306.033c-1.319-1.994-1.523-2.989-1.431-3.322Zm15.52 22.476-8.3 5.257a4.459 4.459 0 0 1-2.39.694h-6.646a4.451 4.451 0 0 1-1.558-.281l-4.775-1.777v-4.8a.446.446 0 1 0-.892 0v5.879a.4.4 0 0 1-.4.4H1.294a.4.4 0 0 1-.4-.4V18.185a.4.4 0 0 1 .4-.4h2.047a.4.4 0 0 1 .4.4v2.416a.446.446 0 1 0 .892 0v-1.255c3.688.028 4.517 1.972 7.044 2.329h.011l4.932.568a1.9 1.9 0 0 1 1.624 1.678l-.006.848h-4.6a.446.446 0 0 0 0 .892h5.042a.461.461 0 0 0 .178-.037l8.111-3.571c.583-.259 1.115-.3 1.476.234a1.018 1.018 0 0 1-.142 1.314Z"
          />
          <path
            data-name="Path 685"
            d="M16.316 20.227a.446.446 0 0 0 .446-.446v-.739a2.612 2.612 0 0 0 2.141-2.161 2.287 2.287 0 0 0-1.575-2.616c-.2-.072-.392-.141-.565-.208v-2.842a1.833 1.833 0 0 1 .867.381.446.446 0 0 0 .6-.658 2.763 2.763 0 0 0-1.469-.623v-.634a.446.446 0 1 0-.892 0v.67a3.282 3.282 0 0 0-.331.081 2.156 2.156 0 0 0-1.475 1.692 1.885 1.885 0 0 0 .613 1.858 5.4 5.4 0 0 0 1.193.674v3.526a2.368 2.368 0 0 1-1.387-.481.446.446 0 1 0-.488.746 3.265 3.265 0 0 0 1.875.626v.708a.446.446 0 0 0 .447.446Zm-1.089-6.946a1 1 0 0 1-.287-.992 1.275 1.275 0 0 1 .856-1l.074-.02v2.408a3.761 3.761 0 0 1-.639-.396Zm1.8 1.825a1.4 1.4 0 0 1 .993 1.627 1.736 1.736 0 0 1-1.261 1.4v-3.121Z"
          />
        </g>
      </g>
    </svg>
  );
};
export default SvgFinanceEconomy;
